import React from 'react'

function Teams() {
  return (
    <div>
      Teams
    </div>
  )
}

export default Teams
